import { createSlice } from "@reduxjs/toolkit";
import { triggerWelcomeEmailAPI } from "../../services/triggerWelcomeEmail";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const triggerWelcomeEmailSlice = createSlice({
  name: "triggerWelcome",
  initialState: data,
  reducers: {
    triggerWelcomeInfo(state) {
      state.isLoading = true;
    },
    triggerWelcomeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    triggerWelcomeFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    triggerWelcomeReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const triggerWelcomeEmailHandler = (data) => async (dispatch) => {
  try {
    dispatch(triggerWelcomeEmailAction.triggerWelcomeInfo());
    const response = await triggerWelcomeEmailAPI(data);
    dispatch(triggerWelcomeEmailAction.triggerWelcomeSuccess(response));
  } catch (e) {
    dispatch(triggerWelcomeEmailAction.triggerWelcomeFailure(e));
  }
};
export default triggerWelcomeEmailSlice.reducer;
export const triggerWelcomeEmailAction = triggerWelcomeEmailSlice.actions;
